import { MenuItem, Select, Stack, TextField, Grid } from "@mui/material"
import { useState } from "react"
import Modal from "../ui/Modal"
import FormItem from "../ui/FormItem"
import { createAsset } from "../../api"
import { useSnackbar } from "notistack"

const assetTypes = [
  { label: "New", value: "NEW" },
  { label: "Working", value: "WORKING" },
  { label: "Backup", value: "BACKUP" },
  { label: "End of life", value: "END_OF_LIFE" },
  { label: "Removed", value: "REMOVED" },
]

const AddAsset = ({ data, ...props }) => {
  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const [assetDetails, setAssetDetails] = useState({
    name: "",
    status: "NEW",
    price: 0,
    currency: "INR",
    model: "",
    serialNumber: "",
  })

  const handleChange = (event) => {
    const { name, value } = event.target
    setAssetDetails({
      ...assetDetails,
      [name]: value,
    })
  }

  const handleSubmit = () => {
    setLoading(true)
    createAsset(assetDetails)
      .then((res) => {
        enqueueSnackbar("Asset added.", { variant: "success" })
        props.refresh()
        props.close()
      })
      .catch((err) => enqueueSnackbar(err.data, { variant: "error" }))
      .finally(() => setLoading(false))
  }

  return (
    <Modal
      {...props}
      title="Add Asset"
      actionText={"Add"}
      action={handleSubmit}
      loading={loading}
    >
      <Stack>
        <Stack direction={"column"} spacing={2} alignItems="center">
          <FormItem label="Asset Name">
            <TextField
              name="name"
              value={assetDetails.name}
              onChange={handleChange}
            />
          </FormItem>
          <FormItem label="Status">
            <Select
              name="status"
              value={assetDetails.status}
              onChange={handleChange}
            >
              {assetTypes.map((type) => (
                <MenuItem value={type.value}>{type.label}</MenuItem>
              ))}
            </Select>
          </FormItem>
        </Stack>
        <Stack direction={"row"} spacing={2} alignItems="center">
          <FormItem label="Price">
            <Grid container spacing={1} width={"100% "}>
              <Grid item xs={3}>
                <Select
                  name="currency"
                  value={assetDetails.currency}
                  onChange={handleChange}
                  fullWidth
                >
                  <MenuItem value="INR">₹</MenuItem>
                  <MenuItem value="USD">$</MenuItem>
                </Select>
              </Grid>
              <Grid item xs={9}>
                <TextField
                  name="price"
                  value={assetDetails.price}
                  onChange={handleChange}
                  fullWidth
                  type={"number"}
                />
              </Grid>
            </Grid>
          </FormItem>
        </Stack>

        <Stack direction={"column"} spacing={2} alignItems="center">
          <FormItem label="Model">
            <TextField
              name="model"
              value={assetDetails.model}
              onChange={handleChange}
            />
          </FormItem>
          <FormItem label="Serial No.">
            <TextField
              name="serialNumber"
              value={assetDetails.serialNumber}
              onChange={handleChange}
            />
          </FormItem>
        </Stack>
      </Stack>
    </Modal>
  )
}

export default AddAsset
